export enum PromoOfferType {
	HOME = "home",
	MEMBERSHIP = "membership",
	CASINO = "casino",
	NEWS = "news",
}
